import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';
import { NotificationService } from '../_services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  
  constructor(
    private authService: AuthService, 
    private router: Router,
    private notify: NotificationService
  ) { }

  isLoggedInAsAdmin(): boolean {
    const isLogged = this.authService.isLoggedInAdmin(),
          isClientIdZero = this.authService.getAdminUser()?.clientId === 0,
          isAdminRole = this.authService.getAdminUser()?.role === 0;

    return isLogged && isClientIdZero && isAdminRole;
  }

  navigateLogin(): void {
    this.notify.warning('Morate se ulogovati');
    this.router.navigateByUrl('/login');
  }

  canActivate(): boolean {
    if (this.isLoggedInAsAdmin()) {
      return true;
    }

    this.navigateLogin();
    return false;
  }
}